module.exports = __webpack_public_path__ + "assets/175e21980753b2437c4fb341e472ed8d.png";